<template>
  <v-container class>
    <v-row dense>
      <v-col cols="12" sm="6" md="6">
        <v-card class="pa-0 ma-3" style="margin-top: 5px; height: 100%" outlined tile>
          <v-list>
            <v-list-item class="deep-purple lighten-4 mt-n2">
              <v-list-item-content>
                <v-list-item-title class="headline">Your Account</v-list-item-title>
                <v-list-item-subtitle>Manage your account</v-list-item-subtitle>
                <v-list-item-subtitle>--</v-list-item-subtitle>
              </v-list-item-content>
              <v-btn color="orange darken-2" dark @click="logout">
                <v-icon dark left>mdi-exit-to-app</v-icon>Logout
              </v-btn>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle>Your current email:</v-list-item-subtitle>
                <v-list-item-title>{{ userInfo.email }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle>Last login:</v-list-item-subtitle>
                <v-list-item-title>{{ displayLastLoggedIn }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle>Your trial end-date:</v-list-item-subtitle>
                <v-list-item-title>{{ trialEnd }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-list class="ma-0 pa-0">
            <v-subheader>Select your preferred date format</v-subheader>
            <v-list-item>
              <v-list-item-content class="pa-0 my-n3">
                <v-select
                  class="body-1"
                  outlined
                  dense
                  v-model="item.dateFormat"
                  :items="dateFormatOptions"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-list class="pa-0 mt-n3">
            <v-subheader>Select your preferred accounting method</v-subheader>
            <v-list-item>
              <v-list-item-content class="pa-0 my-n3">
                <v-select
                  class="body-1"
                  outlined
                  dense
                  v-model="item.accounting"
                  :items="accounting"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-card class="pa-0 ma-3" style="margin-top: 5px; height: 100%" outlined tile>
          <v-list>
            <v-list-item class="indigo lighten-4 mt-n2 mb-4">
              <v-list-item-content>
                <v-list-item-title class="headline">Status</v-list-item-title>
                <v-list-item-subtitle>Enter the 'states' your projects can be in</v-list-item-subtitle>
                <v-list-item-subtitle>(i.e. 'Enquiry', 'Current', 'Closed', ...)</v-list-item-subtitle>
              </v-list-item-content>
              <v-btn
                class="mt-n2 mr-n1 ml-4"
                fab
                dark
                small
                color="pink"
                @click="doShowDialog('statuses', 'status', -1, '')"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-list-item>
            <v-list-item v-for="(status, i) in item.statuses" :key="i" style="min-height: 36px; ">
              <v-list-item-content
                class="pa-0 mb-1"
                @click="doShowDialog('statuses', 'status', i, status)"
              >
                <span class="lbl-setting">{{ status }}</span>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-card class="pa-0 ma-3" style="margin-top: 5px; height: 100%" outlined tile>
          <v-list>
            <v-list-item class="blue lighten-4 mt-n2 mb-4">
              <v-list-item-content>
                <v-list-item-title class="headline">Project Types</v-list-item-title>
                <v-list-item-subtitle>What 'type' of projects do you have?</v-list-item-subtitle>
                <v-list-item-subtitle>(i.e. 'Single Story Rear Extension', 'Loft Conversion', ...)</v-list-item-subtitle>
              </v-list-item-content>
              <v-btn
                class="mt-n2 mr-n1 ml-4"
                fab
                dark
                small
                color="pink"
                @click="doShowDialog('types', 'type', -1, '')"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-list-item>

            <v-list-item v-for="(type, i) in item.types" :key="i">
              <v-list-item-content
                class="pa-0 mb-1"
                @click="doShowDialog('types', 'type', i, type)"
              >
                <span class="lbl-setting">{{ type }}</span>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-card class="pa-0 ma-3" style="margin-top: 5px; height: 100%" outlined tile>
          <v-list>
            <v-list-item class="teal lighten-4 mt-n2">
              <v-list-item-content>
                <v-list-item-title class="headline">Link your Account</v-list-item-title>
                <v-list-item-subtitle>Login easier by connecting through Google</v-list-item-subtitle>
                <v-list-item-subtitle>or Facebook</v-list-item-subtitle>
              </v-list-item-content>
              <!-- <v-btn
                class="mt-n2 mr-n1 ml-4"
                fab
                dark
                small
                color="pink"
                @click="doShowDialog('types', 'type', -1, '')"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>-->
            </v-list-item>
            <v-divider class="mb-4"></v-divider>
            <v-list-item @click="linkWithGoogle">
              <v-list-item-content>
                <v-btn color="primary" large outlined class="mt-3">
                  Link with Google:
                  <v-icon large class="ml-2">mdi-google</v-icon>
                </v-btn>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="linkWithFacebook" class="mt-n6">
              <v-list-item-content>
                <v-btn color="primary" large outlined class="mt-3">
                  Link with Facebook:
                  <v-icon large class="ml-2">mdi-facebook</v-icon>
                </v-btn>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="unlinkWithGoogle">
              <v-list-item-content>
                <v-btn color="primary" large outlined class="mt-3">
                  Unlink with Google:
                  <v-icon large class="ml-2">mdi-google</v-icon>
                </v-btn>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="unlinkWithFacebook" class="mt-n6">
              <v-list-item-content>
                <v-btn color="primary" large outlined class="mt-3">
                  Unlink with Facebook:
                  <v-icon large class="ml-2">mdi-facebook</v-icon>
                </v-btn>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <!-- <v-row align="center" justify="center" class="ma-5">
        <div>
         
        </div>
      </v-row>-->

      <!-- <v-card class="red mx-auto pa-1" style="position: fixed; top: 70px; ">
      <v-card-title>
        <v-btn>Save</v-btn>
        <span :class="['headline indigo--text text--darken-2 ml-2']">status</span>
      </v-card-title>
      </v-card>-->

      <v-row justify="center">
        <v-dialog v-model="showDialog" max-width="350px">
          <DialogSettingsFieldUpdate :obj="obj" />
        </v-dialog>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import { db } from "../auth";
import { storeprops } from "../store/helpers.js";
import DialogSettingsFieldUpdate from "../components/dialogs/DialogSettingsFieldUpdate";
import { linkWithGoogle, unlinkWithGoogle, signOut } from "../auth";
import { getFormattedDate, getNiceDateTime } from "@/shared";

export default {
  components: { DialogSettingsFieldUpdate },
  props: {
    //source: String
  },
  data: () => ({
    obj: null,
    showDialog: false,
    email: "hello@gmail.com",
    accounting: [
      {
        value: "cash",
        text: "Cash basis - (when money actually comes in / goes out",
      },
      { value: "traditional", text: "Traditional - Based on Invoice dates" },
    ],
    dateFormatOptions: [
      { value: "DD MMM YYYY", text: "DD MMM YYYY - [02 Mar 2020]" },
      { value: "YYYY MM DD", text: "YYYY MM DD - [2020 03 02]" },
    ],
  }),
  computed: {
    ...storeprops,
    item() {
      return this.$store.getters.userInfoCloned;
    },
    displayLastLoggedIn() {
      if (!this.userInfo.lastLogin) return "--";
      return getNiceDateTime(this.userInfo.lastLogin);
    },
    trialEnd() {
      return getFormattedDate(this.userInfo.trialEnd);
    },
  },
  methods: {
    logout() {
      signOut();
    },
    linkWithGoogle() {
      linkWithGoogle((error) => alert(error));
    },
    unlinkWithGoogle() {
      unlinkWithGoogle((error) => alert(error));
    },
    linkWithFacebook() {
      //linkWithGoogle(error => alert(error));
    },
    unlinkWithFacebook() {
      //unlinkWithGoogle(error => alert(error));
    },
    doShowDialog(field, header, i, value) {
      let toggle = (b) => (this.showDialog = b);
      let obj = {};
      obj.inNewMode = i == -1;
      obj.header = header;
      obj.field = field;
      obj.item = { text: value };
      obj.close = () => toggle(false);
      obj.update = (newValue) => {
        if (i == -1) this.item[field].push(newValue);
        else this.item[field][i] = newValue;
        let objInfo = { field, data: this.item[field] };
        this.$store.dispatch("updateUserInfo", objInfo);
        toggle(false);
      };
      obj.remove = (value) => {
        this.item[field].splice(i, 1);
        let objInfo = { field, data: this.item[field] };
        this.$store.dispatch("updateUserInfo", objInfo);
        toggle(false);
      };
      this.obj = obj;
      toggle(true); // open the dialog
    },
  },
  watch: {
    "item.dateFormat": function (newValue, oldValue) {
      let objInfo = { field: "dateFormat", data: newValue };
      this.$store.dispatch("updateUserInfo", objInfo);
    },
    "item.accounting": function (newValue, oldValue) {
      let objInfo = { field: "accounting", data: newValue };
      this.$store.dispatch("updateUserInfo", objInfo);
    },
  },

  mounted() {
    //debugger;
    // const { currentUser } = firebase.auth();
    // this.user = currentUser;
  },
};
</script>

<style lang="scss" scoped>
.lbl-setting {
  border: 2px solid rgba(128, 128, 128, 0.555);
  border-radius: 3px;
  background: #f1f1f12e;
  cursor: pointer;
  padding: 7px;
  margin-bottom: 2px;
  transition: all 0.2s;
}
.lbl-setting:hover {
  background: #f1f1f0c4;
  border: 2px solid gray;
}
</style>